// src/modules/app-views/_apps/appmulti/leads/pages/Init/components/LeadsPreviewHeader/index.jsx
import { Divider, Flex, Typography, theme } from 'antd';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';
import { parsePhoneToDisplay } from 'utils/helpers';
import app from 'configs/ConfigIndex';

const { Text, Title } = Typography;

const dividerStyle = { margin: '24px 0 16px' };
const titleStyle = { marginBottom: 4 };
const fieldsWrapStyle = { marginTop: 16 };
const labelStyle = { fontSize: 13 };
const valueStyle = { fontSize: 13 };

const LeadsPreviewHeader = ({ selectedDocument: r }) => {
  const { token } = theme.useToken();
  const baseColor = app?.baseColor || token.colorPrimary;
  const bgBarStyle = {
    height: 56,
    marginLeft: -24,
    marginRight: -24,
    marginTop: -24,
    marginBottom: 20,
    backgroundColor: baseColor,
  };

  if (!r) return null;

  const q = r?.customData?.quotations?.[0];

  return (
    <div>
      <div style={bgBarStyle} />
      <div style={{ textAlign: 'center' }}>
        <Title level={4} style={titleStyle}>
          {r?.name || '—'}
        </Title>
        <div style={fieldsWrapStyle}>
          <Flex vertical gap={4} style={{ width: '100%' }}>
            {r?.email && <InfoRow label={translateX('email')} value={r.email} token={token} />}
            {r?.phone && (
              <InfoRow
                label={translateX('phone')}
                value={parsePhoneToDisplay(r.phone)}
                token={token}
              />
            )}
            {q?.destiny && (
              <InfoRow
                label={translateX('destiny')}
                value={translateX(q.destiny)}
                token={token}
              />
            )}
            {q?.departure && (
              <InfoRow
                label={translateX('departure')}
                value={dayjs(q.departure).format('L')}
                token={token}
              />
            )}
            {q?.arrival && (
              <InfoRow
                label={translateX('arrival')}
                value={dayjs(q.arrival).format('L')}
                token={token}
              />
            )}
          </Flex>
        </div>
        <Divider style={dividerStyle} />
      </div>
    </div>
  );
};

export default LeadsPreviewHeader;

function InfoRow({ label, value, token, strong = false }) {
  if (!value) return null;
  const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    borderBottom: `1px solid ${token?.colorBorderSecondary}`,
  };
  return (
    <div style={rowStyle}>
      <Text type="secondary" style={labelStyle}>
        {label}:
      </Text>
      <Text strong={strong} style={valueStyle}>
        {value}
      </Text>
    </div>
  );
}
